






























import { defineComponent } from '@vue/composition-api';

const PartExpense = defineComponent({
  props: {
    title: {},
    usage: {},
    total: {},
    sum: {},
    totalDiscount: {},
    list: { default: () => [] },
  },
  setup() {
    const toCurrency = (amount: number) => parseFloat(`${amount}` || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

    return {
      toCurrency,
    };
  },
});

export default PartExpense;
